import moment from 'moment'

export function getCurrentDate() {
  return moment(new Date()).format('YYYY-MM-DD')
}

export function getCurrentDateWithType() {
  return moment(new Date()).format('DD MMM, YYYY')
}

export function getNextYearsDate(year: number) {
  return moment(new Date()).add(year, 'years').format('DD MMM, YYYY')
}

export function parseDate(date) {
  if (date) {
    const parsed = moment(date, 'YYYY-MM-DDTHH:mm:ss')
    // Only show time if the date string contains a meaningful time (non-midnight)
    const hasTime = parsed.hours() !== 0 || parsed.minutes() !== 0 || parsed.seconds() !== 0
    if (hasTime) {
      return parsed.format('DD, MMM YYYY HH:mm A')
    }
    return parsed.format('DD, MMM YYYY')
  }
  return ''
}
export function formatDate(date) {
  if (date) {
    return moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD, MMM, YYYY')
    // moment(new Date()).add(30, 'years').format('DD MMM, YYYY')
  }
  return ''
}

export const wait = (msec: number) =>
  new Promise((resolve, _) => {
    setTimeout(resolve, msec)
  })

export const getCurrentDateTimeForApi = () => moment().format('YYYY-MM-DDTHH:mm').toString()
